import { useTasks } from './store'

export function useCreateTask() {
	return useTasks((state) => state.create)
}
